import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03fc2ac5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview-buttongroup" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["aria-label"]

import { useStore } from "vuex";
import RotateClockwise from "@/components/icons/RotateClockwise.vue";
import RotateCounterClockwise from "@/components/icons/RotateCounterClockwise.vue";
import ZoomIn from "@/components/icons/ZoomIn.vue";
import ZoomOut from "@/components/icons/ZoomOut.vue";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewButtongroup',
  setup(__props) {

const store = useStore();
const i18n = window.measurementSelectorVariables.i18n;

const rotation = computed(() => store.getters.rotation);
const zoom = computed(() => store.getters.zoom);
const updateZoom = (data: number) => store.commit('updateZoom', data);
const updateRotation = (data: number) => store.commit('updateRotation', data);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (updateRotation( rotation.value - 90 ))),
      type: "button",
      class: "preview-buttongroup__button",
      "aria-label": _unref(i18n).previewControls.rotateCounterClockwise
    }, [
      _createVNode(RotateCounterClockwise, { "aria-hidden": "true" })
    ], 8, _hoisted_2),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (updateRotation( rotation.value + 90 ))),
      type: "button",
      class: "preview-buttongroup__button",
      "aria-label": _unref(i18n).previewControls.rotateClockwise
    }, [
      _createVNode(RotateClockwise, { "aria-hidden": "true" })
    ], 8, _hoisted_3),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (updateZoom( Math.max( 1, zoom.value - 1 ) ))),
      type: "button",
      class: "preview-buttongroup__button",
      "aria-label": _unref(i18n).previewControls.zoomOut
    }, [
      _createVNode(ZoomOut, { "aria-hidden": "true" })
    ], 8, _hoisted_4),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (updateZoom( zoom.value + 1 ))),
      type: "button",
      class: "preview-buttongroup__button",
      "aria-label": _unref(i18n).previewControls.zoomIn
    }, [
      _createVNode(ZoomIn, { "aria-hidden": "true" })
    ], 8, _hoisted_5)
  ]))
}
}

})